/**
 * # isInteger
 * Number.isInteger() polyfill from MDN
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger#Polyfill
 *
 * @param {Number} value
 * @return  {Boolean}
 *
 * @example
 * isInteger(4);
 *
 * @module helpers/util/is-integer.js
 */
function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

export default isInteger;
